module.exports = __webpack_public_path__ + "img/video-thumb-6-fr.eae4c1f2.png";